module.exports = __webpack_public_path__ + "static/media/1POLICY47.5cef29f5.jpg";